import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RenderInputError from "../Login/RenderInputError/RenderInputError";
import { useHistory } from "react-router-dom";
import PrivacyQuestionsValues from "../../entities/PrivacyQuestionsValues";
import CircleLoading from "../../components/CircleLoading/CircleLoading";
import { GetMemberQuestions } from "../../services/GetMemberQuestions";
import { GetQuestions } from "../../services/GetQuestions";
import {
  CreateUserQuestions,
  Question,
  QuestionAndAnswers,
  UserQuestion,
} from "../../services/CreateUserQuestions";
import {
  GetMemberDetails,
  memberDetailsUtil,
  MEMBER_QUESTIONS_NO_DATA,
} from "../../services/GetMemberDetails";
import { GetMemberFunds } from "../../services/GetMemberFunds";
import { useDispatch, useSelector } from "react-redux";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import ErrorPopup from "../../components/ErrorPopup/ErrorPopup";
import { getUserFunds } from "../../services/getUserFunds";
import {
  setHaveMessages,
  setIsAmit,
  setIsOnline,
  setIsPensioner,
  setUserFirstName,
  setUserFunds,
  setUserLastName,
} from "../../state/actions/UserActions";

import "./PrivacyQuestions.scss";
import { VerifyUserAnswersForQuestions } from "../../services/VerifyUserAnswersForQuestions";
import {
  UpdateMemberDetails,
  updateMemberDetailsUtil,
} from "../../services/UpdateMemberDetails";
import RequestAcceptedPopup from "../../components/RequestAcceptedPopup/RequestAcceptedPopup";
import useInputFocus from "../../customHooks/useInputFocus";
import Selecte from "../../components/Select/Select.UiComponent";

// eslint-disable-next-line
const regex_symbols = /[-!$%^&*()_+|~=`{}\[\]:\/;<>?,.@#]/;


const PrivacyQuestions = () => {
  const { t, i18n } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const { userId } = useSelector((state: any) => state.UserReducer);
  const [userQuestions, setUserQuestions] = useState<UserQuestion[]>([]);
  const [questionOptions, setQuestionOptions] = useState<Question[]>([]);
  const [clickbtnsub , setClickbtnsub] = useState<boolean>(false);
  const [haveQuestions, setHaveQuestions] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);




  const validate = (values: PrivacyQuestionsValues) => {
    const errors: any = {};
    
    if (!values.firstQuestion || values.firstQuestion.length < 1) {
      errors.firstQuestion = t("PrivacyQuestions.firstQuestionNull");
    }

    if (!values.firstAnswer) {
      errors.firstAnswer = t("PrivacyQuestions.firstAnswerNull");
    } else if (values.firstAnswer.length > 50) {
      errors.firstAnswer = t("PrivacyQuestions.inputError");
    } else if (
      values.firstAnswer.split("").filter((char: string) => char === "0")
        .length === values.firstAnswer.length
    ) {
      errors.firstAnswer = t("PrivacyQuestions.inputError");
    }


    if (!values.secondQuestion || values.secondQuestion.length < 1) {
      errors.secondQuestion = t("PrivacyQuestions.secondQuestionNull");
    }

    if (!values.secondAnswer) {
      errors.secondAnswer = t("PrivacyQuestions.secondAnswerNull");
    } else if (values.secondAnswer.length > 50) {
      errors.secondAnswer = t("PrivacyQuestions.inputError");
    } else if (
      values.secondAnswer.split("").filter((char: string) => char === "0")
        .length === values.secondAnswer.length
    ) {
      errors.secondAnswer = t("PrivacyQuestions.inputError");
    }
    return errors;
  };

  const formik = useFormik({    
    initialValues: {
      firstQuestion: haveQuestions ? userQuestions[0]?.question : "",
      firstAnswer: "",
      secondQuestion: haveQuestions ? userQuestions[1]?.question : "",
      secondAnswer: "",
    },
    validate,
    enableReinitialize: true,
    onSubmit: async (values: PrivacyQuestionsValues) => {
      if (!haveQuestions) {
        setLoading(true);
        const arrayAnswers = getArrayAnswers(getQuestionAndAnswers(values));
        const submitStatus = await CreateUserQuestions(arrayAnswers);
        if (submitStatus) {
          initUserData();
        } else {
          setLoading(false);
          openErrorPopup();
        }
      } else {
        setLoading(true);
        const arrayAnswers = getArrayAnswers(getQuestionAndAnswers(values));
        const verifyAnswersStatus = await VerifyUserAnswersForQuestions(
          arrayAnswers
        );
        if (verifyAnswersStatus) {
          let updateMemberDetailsBody = localStorage.getItem(
            "updateMemberDetailsBody"
          );
          if (
            updateMemberDetailsBody &&
            isValidParse(updateMemberDetailsBody)
          ) {
            updateMemberDetailsBody = JSON.parse(updateMemberDetailsBody);
            const updateMemberDetailsStatus = await UpdateMemberDetails(
              updateMemberDetailsBody
            );
            if (updateMemberDetailsUtil.isSuccess(updateMemberDetailsStatus)) {
              localStorage.removeItem("updateMemberDetailsBody");
              setLoading(false);
              openSuccessPopUp();
              history.push("/my-details");
            } else {
              setLoading(false);
              openErrorPopup();
            }
          } else {
            setLoading(false);
            openErrorPopup();
          }
        } else {
          setLoading(false);
          openErrorPopup(true);
        }
      }
    },
  });

  const isValidParse = (str: string) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const initUserData = async () => {
    Promise.all([GetMemberDetails(), GetMemberFunds()])
      .then(async (results) => {
        const userDetails = results[0];
        const userFundsData = results[1];
        if (!(memberDetailsUtil.isValid(userDetails) && userFundsData.length)) {
          // example of direction for validation
          openErrorPopup();
        } else {
          const { userFunds, isAmit, isPensioner, haveMessages } =
            await getUserFunds(userFundsData);
          dispatch(setUserFirstName(userDetails.firstName));
          dispatch(setUserLastName(userDetails.lastName));
          dispatch(setUserFunds(userFunds));
          isAmit && dispatch(setIsAmit(isAmit));
          isPensioner && dispatch(setIsPensioner(isPensioner));
          dispatch(setHaveMessages(haveMessages));
          dispatch(setIsOnline(true));
          history.push("/");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getArrayAnswers = (values: QuestionAndAnswers[]) => {
    return values?.map((value: QuestionAndAnswers) => {
      return {
        questionID: getQuestionId(value.question),
        answer: value.answer,
      };
    });
  };

  const getQuestionId = (question: string) => {
    return questionOptions?.filter(
      (questionOption: Question) => question === questionOption.question
    )[0]?.questionID;
  };

  const getQuestionAndAnswers = (values: PrivacyQuestionsValues) => {
    if (values) {
      return [
        {
          question: values.firstQuestion,
          answer: values.firstAnswer,
        },
        {
          question: values.secondQuestion,
          answer: values.secondAnswer,
        },
      ];
    }
    return [];
  };

  const openSuccessPopUp = () => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <RequestAcceptedPopup
          size="m"
          center={true}
          mainLabel={t("general.complete")}
          secondLabel={t("general.dataUpdated")}
        />
      )
    );
  };

  const openErrorPopup = (isAnswersError?: boolean) => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <ErrorPopup
          size="m"
          label={
            isAnswersError
              ? t("PrivacyQuestions.answersError")
              : t("general.error")
          }
          center={true}
        />
      )
    );
  };


  useEffect(() => {

    document.title = "amitim " + 'My Page Title - Amitim';


    async function init() {
      Promise.all([GetMemberQuestions(), GetQuestions()]).then((results) => {
        const _userQuestions = results[0];
        if (i18n.language === "ar") {
          for (let i = 0; i < results[1].length; i++) {
            results[1][i].question = results[1][i].questionArab;
          }
          setQuestionOptions(results[1]);
        }
        setQuestionOptions(results[1]);
        if (isUserHaveQuestions(_userQuestions)) {
          setUserQuestions(_userQuestions);
          setHaveQuestions(true);
        }
        setLoading(false);
      });

    }
    init();
  }, []);

  useEffect(() => {
    document.title = haveQuestions
      ? t("PrivacyQuestions.haveQuestionsTitle")
      : t("PrivacyQuestions.title");
  }, []);


  const InputFocus =  useInputFocus(formik.errors, formik.submitCount , clickbtnsub);
  useEffect(() => {
    if(clickbtnsub){
      setClickbtnsub(false);
    }

  }, [clickbtnsub , formik.errors ,InputFocus]);

  const isUserHaveQuestions = (res: any) =>  res !== MEMBER_QUESTIONS_NO_DATA && res.length;

  return (
    <div className="privacy-questions page">
      <div className="content">
        <div className="wrap-bg-details">
        <form onSubmit={formik.handleSubmit}>
          <div className="privacy-questions-wrap-details">
            {loading ? (
              <CircleLoading />
            ) : (
              <>
                <h1 className="privacy-questions-title">
                  {haveQuestions
                    ? t("PrivacyQuestions.haveQuestionsTitle")
                    : t("PrivacyQuestions.title")}
                </h1>
                <div className="privacy-questions-container">
                  <div className="d-flex align-items-center pq-mt">
                    <Selecte
                        ariaDescribedby="firstQuestion-sr"
                        isAutoFocus = {true} 
                        title={t("PrivacyQuestions.forYourSafety")}
                        isRequired={true}
                        id="firstQuestion"
                        name="firstQuestion"
                        label={`${t("PrivacyQuestions.firstQuestionLabel")}*`}
                        value={formik.setFieldValue}
                        data={formik.values.secondQuestion.length > 0 && formik.values.secondQuestion !== '' ?
                         questionOptions?.filter((questionOption: Question) =>
                           questionOption?.questionID !== getQuestionId(formik.values.secondQuestion)) : questionOptions}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        aria-required="true"
                         />
                  </div>
                  {formik.touched.firstQuestion &&
                    formik.errors.firstQuestion ? (
                    <div style={{ marginTop: -20 }}>
                      <RenderInputError
                        errorLabel={formik.errors.firstQuestion}
                        id={'firstQuestion'} 
                        inputLabel={t("PrivacyQuestions.firstQuestionLabel")} 
                      />
                    </div>
                  ) : null}
                  <div className="d-flex align-items-center pq-mt">
                    <TextField
                      label={`${t("PrivacyQuestions.firstAnswerLabel")}*`}
                      id="firstAnswer"
                      name="firstAnswer"
                      fullWidth
                      variant="standard"
                      value={formik.values.firstAnswer}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      aria-required="true"
                      autoComplete="off"
                      className={`reg-input-focus ${formik.touched.firstAnswer && formik.errors.firstAnswer
                          ? "reg-input-error"
                          : ""
                        }`}
                      InputLabelProps={{
                          "htmlFor": "firstAnswer",
                      }}
                      InputProps={{
                        "aria-describedby":"firstAnswer-sr"
                      }}
                    />
                  </div>
                  {formik.touched.firstAnswer && formik.errors.firstAnswer ? (
                    <div style={{ marginTop: -20 }}>
                      <RenderInputError
                        errorLabel={formik.errors.firstAnswer}
                        id={'firstAnswer'} 
                        inputLabel={t("PrivacyQuestions.firstAnswerLabel")} 
                      />
                    </div>
                  ) : null}
                  <div className="d-flex align-items-center pq-mt">
                    <Selecte
                        ariaDescribedby="secondQuestion-sr"
                        isRequired={true}
                        id="secondQuestion"
                        name="secondQuestion"
                        label={`${t("PrivacyQuestions.secondQuestionLabel")}*`}
                        value={formik.setFieldValue}
                        data={formik.values.firstQuestion.length > 0 && formik.values.firstQuestion !== '' ?
                         questionOptions.filter((questionOption: Question) =>
                            questionOption?.questionID !== getQuestionId(formik.values.firstQuestion)) : questionOptions}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        aria-required="true"
                         />
                  </div>
                  {formik.touched.secondQuestion &&
                    formik.errors.secondQuestion ? (
                    <div style={{ marginTop: -20 }}>
                      <RenderInputError
                        errorLabel={formik.errors.secondQuestion}
                        id={'secondQuestion'} 
                        inputLabel={t("PrivacyQuestions.secondQuestionLabel")} 
                      />
                    </div>
                  ) : null}
                  <div className="d-flex align-items-center pq-mt">
                    <TextField
                      label={`${t("PrivacyQuestions.secondAnswerLabel")}*`}
                      id="secondAnswer"
                      name="secondAnswer"
                      fullWidth
                      variant="standard"
                      autoComplete="off"
                      value={formik.values.secondAnswer}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      aria-required="true"
                      className={`reg-input-focus ${formik.touched.secondAnswer &&
                          formik.errors.secondAnswer
                          ? "reg-input-error"
                          : ""
                        }`}
                      InputLabelProps={{
                          "htmlFor": "secondAnswer",
                      }}
                      InputProps={{
                          "aria-describedby":"secondAnswer-sr"
                      }}
                    />
                  </div>
                  {formik.touched.secondAnswer && formik.errors.secondAnswer ? (
                    <div style={{ marginTop: -20 }}>
                      <RenderInputError
                        errorLabel={formik.errors.secondAnswer}
                        id={'secondAnswer'} 
                        inputLabel={t("PrivacyQuestions.secondAnswerLabel")} 
                      />
                    </div>
                  ) : null}
                </div>
                <button type="submit" onClick={()=>setClickbtnsub(true)}>
                  {t("PrivacyQuestions.saveQuestions")}
                </button>
              </>
            )}
          </div>
        </form>
        </div>
      </div>
    </div>
  );
};

export default PrivacyQuestions;
